var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F4F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 19.3999L17.5 14.2099M13.27 16.9599L22 22.0099L30.73 16.9599M22 32.0799V21.9999M31 25.9999V17.9999C30.9996 17.6492 30.9071 17.3047 30.7315 17.0011C30.556 16.6974 30.3037 16.4453 30 16.2699L23 12.2699C22.696 12.0944 22.3511 12.002 22 12.002C21.6489 12.002 21.304 12.0944 21 12.2699L14 16.2699C13.6963 16.4453 13.444 16.6974 13.2685 17.0011C13.0929 17.3047 13.0004 17.6492 13 17.9999V25.9999C13.0004 26.3506 13.0929 26.6951 13.2685 26.9987C13.444 27.3024 13.6963 27.5545 14 27.7299L21 31.7299C21.304 31.9054 21.6489 31.9979 22 31.9979C22.3511 31.9979 22.696 31.9054 23 31.7299L30 27.7299C30.3037 27.5545 30.556 27.3024 30.7315 26.9987C30.9071 26.6951 30.9996 26.3506 31 25.9999Z",
    stroke: "#6938EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackIcon);
export default __webpack_public_path__ + "182e8a2644e6c6db027bf6ac5066b479.svg";
export { ForwardRef as ReactComponent };